import { getLocalInfo } from '../../util'

const state = {
  isLogin: false,
  userinfo: {}
}

try {
  let localInfo = getLocalInfo('userinfo')
  if (localInfo) {
    state.isLogin = true
    state.userinfo = JSON.parse(localInfo)
  }
} catch (e) { }

const mutations = {
  loginState (state, data) {
    state.isLogin = true
    mutations.changUserInfo(state, data)
  },
  logout (state) {
    state.isLogin = false
    mutations.changUserInfo(state, {})
  },
  changUserInfo (state, data) {
    state.userinfo = data
  }
}

export default {
  state,
  mutations
}




// WEBPACK FOOTER //
// ./src/store/modules/user.js